









import { Component, Vue, Prop, Watch } from 'nuxt-property-decorator'

@Component({})
export default class Button extends Vue {
  @Prop({ default: false })
  disabled: boolean

  isDisabled: boolean

  constructor() {
    super()
    this.isDisabled = this.disabled
  }

  @Watch('disabled')
  onDisabeldChanged() {
    this.isDisabled = this.disabled
  }

  handleClick(e: Event) {
    this.$emit('click', e)
  }

  handleKeypress(e: Event) {
    this.$emit('keypress', e)
  }
}
